/**
 * Dashboard quick-action routing between the navigation trigger and destination dialog.
 *
 * The Dashboard's "New IVR" / "New Order" buttons need the target page to open its creation modal
 * on arrival. Router location.state was rejected DELIBERATELY: the page tests render pages bare
 * (no Router), so adding useLocation would break every existing bare-render test, and history
 * state survives refresh (a reload would silently reopen the modal). A self-consuming
 * sessionStorage key has neither problem: set just before navigating, consumed exactly once on
 * mount, gone on refresh.
 */
const KEY = 'medeffects.quickAction';

export function setQuickAction(action) {
  try {
    sessionStorage.setItem(KEY, action);
  } catch (e) {
    // Storage unavailable (private mode edge case) - the button still navigates; the user just
    // clicks the page's own New button instead. Never let the quick action break navigation.
  }
}

/** Returns true (once) if the given action is pending, and clears it. */
export function consumeQuickAction(action) {
  try {
    if (sessionStorage.getItem(KEY) === action) {
      sessionStorage.removeItem(KEY);
      return true;
    }
  } catch (e) {
    // ignore - same rationale as above
  }
  return false;
}
